import { useRef } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Mousewheel, Autoplay } from 'swiper';
import styled, { th } from '@xstyled/styled-components';

SwiperCore.use([Mousewheel, Autoplay]);

const SliderContainer = styled.divBox`
  display: flex;
  position: relative;

  .swiper-container {
    margin-left: unset;
    margin-right: unset;
  }

  .swiper-wrapper {
    transition-timing-function: linear;
  }

  @media (max-width: desktop) {
    margin-top: 1rem;
  }

  &:after {
    content: '';
    position: absolute;
    right: -0.5rem;
    width: 40px;
    height: 30px;
    background: linear-gradient(to left, #fff, rgba(255, 255, 255, 0));
    z-index: 2;

    @media (max-width: desktop) {
      right: 0.5rem;
    }
  }
`;

const AutoPlaySlider = styled(Swiper)`
  max-width: 98%;

  @media (min-width: desktop) {
    max-width: 570px;
  }

  @media (min-width: lg_desktop) {
    max-width: 680px;
  }

  .swiper-slide {
    max-width: min-content;
  }
`;

const CategoryLabel = styled.divBox`
  font-size: xsmall;
  color: black;
  border: 1px solid ${th.color('purple-100')};
  border-radius: 15px;
  padding: 2px 14px;
  white-space: nowrap;

  &:hover,
  &:active {
    border: 1px solid #96e7e7;
    cursor: pointer;
  }
`;

export default function FilterSlider({ categories }) {
  const sliderRef = useRef();
  const router = useRouter();
  const categoryPath = urlKey => `${router.asPath}/${urlKey}`;

  return (
    <SliderContainer>
      <AutoPlaySlider
        ref={sliderRef}
        slidesPerView="auto"
        spaceBetween={16}
        mousewheel={{ sensitivity: 50 }}
        speed={8000}
        autoplay={{ delay: 0 }}
        loop={categories?.length >= 6 && true}
        resizeObserver={true}
        resistance={false}
      >
        {categories.map(({ name, url_key }) => {
          return (
            <SwiperSlide key={url_key}>
              <Link href={categoryPath(url_key)}>
                <a>
                  <CategoryLabel>{name}</CategoryLabel>
                </a>
              </Link>
            </SwiperSlide>
          );
        })}
      </AutoPlaySlider>
    </SliderContainer>
  );
}
